export { default } from './customer-reviews';
